/**
 * Created by A665445 on 12/05/2017.
 */
 import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
 import { RouterModule } from '@angular/router';

 import { TmmsaisineSharedModule } from '../../shared';
 import {masterProposalRoute} from './master-proposal.route';
 import {MasterProposalService} from './master-proposal.service';
 import {MasterProposalLineService} from './master-proposal-line.service';
 import {MasterProposalComponent} from './master-proposal.component';
 import {ButtonModule, DataTableModule, DialogModule, InputTextModule, MultiSelectModule, DropdownModule} from 'primeng/primeng';


 let ENTITY_STATES = [
     ...masterProposalRoute
 ];

 @NgModule({
     imports: [
         TmmsaisineSharedModule,
         InputTextModule, DataTableModule, ButtonModule, DialogModule, MultiSelectModule, DropdownModule,
         RouterModule.forRoot(ENTITY_STATES, { useHash: true }),

     ],
     declarations: [
         MasterProposalComponent,
     ],
     entryComponents: [
         MasterProposalComponent
     ],
     providers: [
         MasterProposalService,
         MasterProposalLineService
     ],
     schemas: [CUSTOM_ELEMENTS_SCHEMA]
 })
 export class TmmsaisineMasterProposalModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/master-proposal/master-proposal.module.ts